import paymentService from '../services/paymentService';

/** Child purchase invoices for a consolidated invoice, FIFO-sorted (live Paiement numbers). */
export function getConsolidatedChildInvoices(invoice, allInvoices = []) {
  if (!invoice || !paymentService.isConsolidatedInvoice(invoice)) return [];
  const refs = invoice.originalInvoices || [];
  const seen = new Set();
  const children = [];
  for (const ref of refs) {
    const live = paymentService.resolveLiveChildInvoice(ref, allInvoices || []);
    if (!live) continue;
    const key = String(live.id || live.purchaseId || '');
    if (!key || seen.has(key)) continue;
    seen.add(key);
    children.push(live);
  }
  return children.sort((a, b) => {
    const dateA = a.invoiceDate ? new Date(a.invoiceDate).getTime() : 0;
    const dateB = b.invoiceDate ? new Date(b.invoiceDate).getTime() : 0;
    if (dateA !== dateB) return dateA - dateB;
    return String(a.invoiceNumber || '').localeCompare(String(b.invoiceNumber || ''));
  });
}

/** Line items for one child invoice (fallback to total line). */
export function getChildInvoiceDisplayItems(child, isRTL = false) {
  if (Array.isArray(child?.items) && child.items.length > 0) return child.items;
  return [{
    productName: isRTL ? 'إجمالي الفاتورة' : 'Total facture',
    quantity: 1,
    unitPrice: child?.totalAmount || 0,
    totalPrice: child?.totalAmount || 0
  }];
}

export function getChildInvoiceGroupLabel(child, isRTL = false) {
  const prefix = isRTL ? 'فاتورة شراء' : 'Facture achat';
  // Same id as Achats page (purchaseId), not supermarket facture number
  const achatId =
    child?.purchaseId ||
    child?.originalTransactionId ||
    child?.invoiceNumber ||
    child?.id ||
    '—';
  return `${prefix}: ${achatId}`;
}

/**
 * Flat row list for product tables: { type: 'header'|'item', label?, item? }
 */
export function buildGroupedInvoiceProductRows(invoice, allInvoices = [], isRTL = false) {
  const childInvoices = getConsolidatedChildInvoices(invoice, allInvoices);
  if (!childInvoices.length) return null;

  const rows = [];
  childInvoices.forEach((child) => {
    rows.push({ type: 'header', label: getChildInvoiceGroupLabel(child, isRTL) });
    getChildInvoiceDisplayItems(child, isRTL).forEach((item) => {
      rows.push({ type: 'item', item });
    });
  });
  return rows;
}
